<template>
  <b-row v-if="mandatesByCorrespondence.length > 0">
    <b-col>
      <h2 v-if="!withoutTitle">
        <b-badge variant="warning">Voté par correspondance </b-badge>
      </h2>
      <b-table
        class="agv-table"
        bordered
        :items="mandatesByCorrespondence"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
      >
        <template v-slot:cell(building_owner.lastname)="row">
          <b-row class="text-left">
            <b-col>
              {{
                getPersonNameAndGender({
                  personId: row.item.building_owner_id,
                })
              }}
              <br />
              <div>
                <b-badge>
                  {{ getTotalMandateTantiemesChargeGenerale(row.item.id) }}
                </b-badge>
                <b-badge
                  v-if="getReducedMandateTantiemesChargeGenerale(row.item.id)"
                  class="ml-1"
                  variant="warning"
                >
                  {{ getReducedMandateTantiemesChargeGenerale(row.item.id) }}</b-badge
                >
                <b-badge
                  v-if="row.item.docage_id && docageSignDate(row.item)"
                  variant="success"
                  class="ml-1"
                >
                  Voté et signé le {{ docageSignDate(row.item) }}
                </b-badge>
              </div>
            </b-col>
          </b-row>
        </template>

        <template v-slot:cell(mandate)="row">
          {{ getCorrespondanceType(row.item) }}
        </template>
        <template v-slot:cell(reception_date)="row">
          {{ $moment(row.item.reception_date).format("YYYY-MM-DD") }}
        </template>

        <template v-slot:cell(actions)="row">
          <b-button
            variant="none"
            title="Modifier le vote"
            class="tablebutton btn-edit"
            @click="EDIT(row.item)"
          >
            <font-awesome-icon size="2x" icon="pen" />
          </b-button>
          <b-button
            v-if="row.item.voted_by_correspondence != correspondenceTypes.by_app"
            variant="none"
            title="Supprimer le vote"
            class="tablebutton btn-red"
            @click="askDelete(row.item)"
          >
            <font-awesome-icon
              v-if="row.item.voted_by_correspondence != correspondenceTypes.by_app"
              size="2x"
              icon="trash"
            />
          </b-button>
        </template>
      </b-table>
    </b-col>
  </b-row>
</template>

<script>
import MandateORM from "@/store/orm-axios/models/Mandate";
import MandateMW from "@/middlewares/Mandate";

import ResolutionVoteMW from "@/middlewares/ResolutionVote";
import ResolutionVoteORM from "@/store/orm-axios/models/ResolutionVote";

import minutesMixin from "@/mixins/minutes.js";
import correspondenceVotesMixin from "@/mixins/correspondence-votes";

import MeetingCorrespondenceVoteMW from "@/middlewares/MeetingCorrespondenceVote";
import MeetingCorrespondenceVoteORM from "@/store/orm-axios/models/MeetingCorrespondenceVote";

import DocageORM from "@/store/orm-axios/models/Docage";

export default {
  mixins: [minutesMixin, correspondenceVotesMixin],
  props: {
    mandatesByCorrespondence: {
      type: Array,
      default: () => {
        return [];
      },
    },
    withoutTitle: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mandate: null,
      items: [],
      sortBy: "building_owner.lastname",
      sortDesc: false,
      fields: [
        {
          label: "Nom complet",
          key: "building_owner.lastname",
          sortable: true,
          formatter: (value, key, item) => {
            let personName = this.getPersonNameAndGender({
              personId: item.building_owner_id,
            });
            return personName ? personName : "";
          },
          sortByFormatted: true,
        },
        {
          label: "Date de réception",
          key: "reception_date",
          sortable: false,
        },
        {
          label: "Type de votes",
          key: "mandate",
          sortable: false,
        },
      ],
    };
  },
  created() {
    if (this.editable) {
      this.fields.push({
        label: "Actions",
        key: "actions",
        sortable: false,
        // tdClass: "text-left",
      });
    }
  },
  methods: {
    EDIT(mandate) {
      this.$emit("edit", mandate);
    },
    async askDelete(mandate) {
      const questionResult = await this.$swal(this.alertQuestion());
      if (!questionResult.value) return;

      await this.deleteCorrespondence(mandate);
      this.$swal({
        title: "",
        text: "Les votes ont été supprimés",
        icon: "success",
        timer: 3000,
      });
    },
    async deleteCorrespondence(mandate) {
      try {
        this.$store.state.showLoaderOverlay = true;
        await MandateMW.GET(mandate.id);
        var resolution_votes = ResolutionVoteORM.query().where("mandate_id", mandate.id).get();
        if (resolution_votes.length > 0) {
          await ResolutionVoteMW.BULK_DELETE(resolution_votes);
        }
        let meetingCorrespondenceVote = MeetingCorrespondenceVoteORM.getters("getByMandateId")(
          mandate.id
        );
        if (meetingCorrespondenceVote) {
          await MeetingCorrespondenceVoteMW.DELETE(meetingCorrespondenceVote);
        }
        MandateORM.update({
          where: mandate.id,
          data: {
            voted_by_correspondence: 0,
            presence_status: null,
          },
        });

        var m = MandateORM.query()
          .where("id", mandate.id)
          .where("meeting_id", this.$route.params.id)
          .first();
        var mandate2 = MandateORM.query().where("id", m.id).withAllRecursive(2).first();

        if (this.isMeetingStarted) {
          await this.deleteCorrespondenceEvent(mandate2.id, true);
          await this.updateResolutionVoteEventsAfterDeleteCorrespondence(
            mandate2.building_owner_id,
            true
          );
        }

        await MandateMW.PUT(m, false)
          .then(async () => {
            if (
              this.isMeetingStarted &&
              mandate.presence_status != this.mandatePresenceStatuses.invalid_correspondence
            ) {
              await this.updateMeetingVotesNeedRecalculations();
            }

            this.$store.state.showLoaderOverlay = false;
            return "success";
          })
          .catch(err => {
            console.log("error", err);
            this.$store.state.showLoaderOverlay = false;
            return "error";
          });
      } catch (err) {
        console.error("deleteCorrespondence", err);
        this.$store.state.showLoaderOverlay = false;
      }
    },
    isEditable(correspondenceType) {
      if (correspondenceType == this.correspondenceTypes.by_app) {
        return false;
      } else {
        return true;
      }
    },
    getCorrespondanceType(mandate) {
      if (mandate.voted_by_correspondence == this.correspondenceTypes.by_app) {
        return "par l'Espace Proprietaire";
      } else if (mandate.voted_by_correspondence == this.correspondenceTypes.by_email) {
        return "par Email";
      } else if (mandate.voted_by_correspondence == this.correspondenceTypes.by_post) {
        return "par Post";
      } else {
        return "";
      }
    },
    docageSignDate(mandate) {
      const docage = DocageORM.find(mandate.docage_id);
      return docage && docage.sign_date
        ? this.$moment(docage.sign_date).format("DD MMMM YYYY HH:mm")
        : null;
    },
  },
};
</script>

<style>
.table.agv-table tbody tr td {
  vertical-align: middle;
}
</style>
